import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import PostItem from "./PostItem/PostItem";

import Doctor from "./../../../assets/images/Icons/Doctor.svg";

import { faSearch } from "@fortawesome/free-solid-svg-icons";

//Style
import { MDBRow, MDBCol } from "mdbreact";
import "./Post.scss";
import { useSelector } from "react-redux";
import { Language } from "../../../redux/store/base/language";

const specFake = new Array<string>();
specFake.push("الاذن");
specFake.push("الانف");

const Post = () => {
  const state = useSelector(
    (state: { lang: Language }) => state.lang.dictionary
  );

  return (
    <MDBRow className="post mt-3">
      <MDBCol size={"12"} className="d-flex">
        <p>(4,502) {state?.doctors}</p>
        <section className="mr-auto d-flex">
          <div className="input-group ml-3 d-flex">
            <input
              className="form-control my-0 py-1"
              type="text"
              placeholder={`${state?.search} ${state?.doctors}`}
              aria-label="Search"
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <FontAwesomeIcon
                  icon={faSearch}
                  className="d-inline-inline mx-3"
                />{" "}
              </span>
            </div>
          </div>
          <div className="input-group d-flex">
            <select className="browser-default custom-select">
              <option disabled selected>
                {state?.topRated}
              </option>
              <option value="1">Option 1</option>
              <option value="2">Option 2</option>
              <option value="3">Option 3</option>
            </select>
          </div>
        </section>
      </MDBCol>
      <MDBCol size={"12"}>
        <MDBRow>
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
          <PostItem
            Name={"د.مصطفى احمد"}
            Likes={123.5}
            Rating={4.3}
            Profile={Doctor}
            Location={"تبوك - الرياض"}
            Specializ={specFake}
            PostText={
              "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز على الشكل الخارجي للنص أو شكل تو"
            }
          />
        </MDBRow>
      </MDBCol>
    </MDBRow>
  );
};

export default Post;
